const themes = {
  colors: {
    primary: '#1A1A1A',
    secondary: '#E09F1F',
    warning: '#F2B10C',
    danger: '#E74B4B',
    success: '#2BC37F',
    defaultBlue: '#4D8AF0',
    white: '#ffffff',
    black: '#000000',
    darkPrimary: '#111111',
    darkSecondary: '#222222',
    darkTertiary: '#333333',
    darkQuaternary: '#444444',
    grayPrimary: '#666666',
    graySecondary: '#999999',
    lightPrimary: '#eeeeee',
    lightSecondary: '#dddddd',
    lightTertiary: '#cccccc',
    lightQuaternary: '#f4f6f9',
    lightBlue: '#8EA6B3',
    lightGreen: '#128C7E',
  },
  fonts: {
    bold: require('_/assets/enidma/fonts/OpenSans-Bold.ttf'),
    light: require('_/assets/enidma/fonts/OpenSans-Light.ttf'),
    medium: require('_/assets/enidma/fonts/OpenSans-SemiBold.ttf'),
    regular: require('_/assets/enidma/fonts/OpenSans-Regular.ttf'),
    semibold: require('_/assets/enidma/fonts/OpenSans-SemiBold.ttf'),
  },
  images: {
    logo: require('_/assets/enidma/logo.png'),
    buildings: require('_/assets/invenzi/edificios.png'),
    noCompany: require('_/assets/enidma/no-company.png'),
    emailVerification: require('_/assets/enidma/emailVerification.png'),
    forgotPassword: require('_/assets/enidma/forgot-password.png'),
    empty: require('_/assets/enidma/empty.png'),
    bigCalendar: require('_/assets/enidma/big-calendar.png'),
    intro1: require('_/assets/enidma/intro1.png'),
    intro2: require('_/assets/enidma/intro2.png'),
    intro3: require('_/assets/enidma/intro3.png'),
    emailSent: require('_/assets/enidma/email-sent.png'),
    loginImage: require('_/assets/enidma/login-img.png'),
    packageImg: require('_/assets/enidma/package.png'),
    spinner: require('_/assets/enidma/spinner.png'),
    avatarSquare: require('_/assets/enidma/avatar-square.png'),
    checkCircle: require('_/assets/enidma/check-circle.png'),
    noMeeting: require('_/assets/enidma/no-meeting.png'),
    qrcodeIcon: require('_/assets/qrcode-icon.png'),
    calendarIcon: require('_/assets/calendar-icon.png'),
    calendar: require('_/assets/calendar.png'),
    googleIcon: require('_/assets/google-icon.png'),
    googleWalletIcon: require('_/assets/google-wallet-icon.png'),
    hidLogo: require('_/assets/hid-logo.png'),
    appleWalletIcon: require('_/assets/apple-wallet-icon.png'),
    cardBackground: require('_/assets/card-background.jpg'),
    invenziLogo: require('_/assets/invenzi-logo.png'),
    switchCamera: require('_/assets/switchCamera.png'),
    qrCodeBorder: require('_/assets/qrCodeBorder.png'),
    splash: require('_/assets/enidma/splash.png'),
    emptyInvites: require('_/assets/enidma/emptyInvites.png'),
    receivedInvite: require('_/assets/enidma/receivedInvite.png'),
    notFoundInvite: require('_/assets/enidma/notFoundInvite.png'),
    meetingError: require('_/assets/enidma/meetingError.png'),
    qrcodeFrame: require('_/assets/enidma/qrcodeFrame.png'),
    qrcodeExpired: require('_/assets/enidma/qrcodeExpired.png'),
    spaceManagementIcon: require('_/assets/spaceManagement.png'),
  },
};

export default themes;
